import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import transporter from "../../../../assets/info/transporter-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import part1 from "../../../../assets/info/vw-transporter/transporter-t5-fig-1.jpg";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";
import styled from "styled-components";
import { popularVehicle } from "../../../../vars/popularVehicles";

const VWTransporter = () => {
  useSmallNav("Volkswagen Transporter");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Volkswagen Transporter"} bolder />
        <InfoHero image={transporter} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={
                "Is your T5 or T6 Transporter heavily laden? Been converted to a camper?"
              }
            />
            <InfoHeader text={"Then we have what you need!"} />
            <p>
              Pedders Suspension is proud to release a Spring and Damper Kit to
              suit the rear of the T5 & T6 VW Transporter. The kit has been
              specifically designed for those owners of working vans or campers
              where the original set up is found not be suitable for ongoing
              tasks at hand such as load carrying,and camper conversions where
              additional weight has been added. The kit is designed to assist in
              reducing body roll and float.
            </p>
            <p>
              The Pedders Gas Shock Absorber system has a unique nature of the
              oil flow process which provides a progressive response to ever
              changing road conditions. Unlike existing 'position sensitive'
              shock absorbers that switch between firmer and softer control,
              Pedders VRD shocks provide a progressive shock response rate.
            </p>
            <p>
              The Pedders Heavy Duty springs are manufactured in accordance with
              our demanding criteria to ensure continued performance. Full
              details of this process see this video on the left.
            </p>
            <InfoHeader
              size="smaller"
              text={
                "Available for all VW T5 & T6 Transporter models including the 4motion"
              }
            />
            <p>You can buy the following parts:</p>
            <div>
              <StyledLink href="https://pedders.eu/details/7891">
                2 Pedders Heavy Duty Coil Springs (7891)
              </StyledLink>
            </div>
            <div>
              <StyledLink href="https://pedders.eu/details/120216">
                2 Pedders Uprated Rear Dampers (120216)
              </StyledLink>
            </div>
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Volkswagen")
              .models.find((e) => e.display === "Transporter")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              title={"VW Transporter Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <Gray>
              <InfoHeader
                size="smaller"
                text={"VW T5 Transporter Rear Suspension Kit"}
              />
              <div>
                <StyledImgParts
                  src={part1}
                  alt="VW T5 Transporter Rear Suspension Kit"
                />
              </div>
              <ul>
                <li>2 Heavy duty coil springs</li>
                <li>2 Uprated rear dampers</li>
              </ul>
            </Gray>
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/KnT6sI4QaYk"
              title={"VW Transporter Video 2"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </InfoGrid>
        <InfoFooter make="Volkswagen" model="Transporter" />
      </Container>
    </section>
  );
};

export default VWTransporter;

const StyledLink = styled.a`
  color: #444444;
  &:hover {
    color: #dc3332;
  }
`;

const StyledImgParts = styled.img`
  width: 100%;
  margin-bottom: 10px;
`;

const Gray = styled.div`
  padding: 25px;
  border-radius: 5px;
  background-color: #f4f4f4;
  margin: 30px 0;
`;
